// Sides, intelligences, and UnitType — mpshared/side.h (kut values are level-format
// contract: "can not be changed without breaking old levels").

export const ksideNeutral = 0;
export const kside1 = 1;
export const kside2 = 2;
export const kside3 = 3;
export const kside4 = 4;
export const kcSides = 5;

// mpshared/mpht.h:59-65 — side masks
export const ksidmNeutral = 1 << ksideNeutral;
export const ksidmAll =
  ksidmNeutral | (1 << kside1) | (1 << kside2) | (1 << kside3) | (1 << kside4);

export const knIntelligenceHuman = 0;
export const knIntelligenceComputer = 1;
export const knIntelligenceComputerOvermind = 2;
export const knIntelligenceComputerNeutral = 3;

export const kutNone = -1;
export const kutShortRangeInfantry = 0;
export const kutLongRangeInfantry = 1;
export const kutTakeoverSpecialist = 2;
export const kutMachineGunVehicle = 3;
export const kutLightTank = 4;
export const kutRocketVehicle = 5;
export const kutMediumTank = 6;
export const kutGalaxMiner = 7;
export const kutMobileHeadquarters = 8;
export const kutReactor = 9;
export const kutProcessor = 10;
export const kutWarehouse = 11;
export const kutHumanResourceCenter = 12;
export const kutVehicleTransportStation = 13;
export const kutRadar = 14;
export const kutResearchCenter = 15;
export const kutHeadquarters = 16;
export const kutMachineGunTower = 17;
export const kutRocketTower = 18;
export const kutAndy = 19;
export const kutArtillery = 20;
export const kutReplicator = 21;
export const kutFox = 22;
export const kutMax = 23;

// mpshared/mpht.h:33-35
export const kcPlayersMax = 4 + 1; // + 1 computer controlled neutral player
export const kpidNeutral = 0xffff;

// mpshared/mpht.h:69-79 — player flags (word m_wf)
export const kfPlrInUse = 0x0001;
export const kfPlrReady = 0x0002;
export const kfPlrComputer = 0x0004;
export const kfPlrUnfulfilled = 0x0008;
export const kfPlrStructureAttacked = 0x0010;
export const kfPlrComputerOvermind = 0x0020;
export const kfPlrAutoRepair = 0x0040;
export const kfPlrObserver = 0x0100;
export const kfPlrCreator = 0x0400;

// game/ht.h:288-298 — handicap flags
export const kfHcapIncreasedFirePower = 0x0001;
export const kfHcapDecreasedTimeToBuild = 0x0002;
export const kfHcapIncreasedMinerLoadValue = 0x0004;
export const kfHcapShowEnemyBuildProgress = 0x0010;
export const kfHcapShowEnemyResourceStatus = 0x0020;
export const kfHcapIncreasedArmor = 0x0040;
export const kfHcapEasy =
  kfHcapDecreasedTimeToBuild |
  kfHcapIncreasedArmor |
  kfHcapIncreasedFirePower |
  kfHcapIncreasedMinerLoadValue |
  kfHcapShowEnemyBuildProgress |
  kfHcapShowEnemyResourceStatus;
export const kfHcapNormal =
  kfHcapDecreasedTimeToBuild |
  kfHcapIncreasedArmor |
  kfHcapShowEnemyBuildProgress |
  kfHcapShowEnemyResourceStatus;
export const kfHcapHard = kfHcapShowEnemyBuildProgress;
export const kfHcapDefault = kfHcapNormal;

// mpshared/mpht.h:36-40 — lag states
export const knLagNone = 0;
export const knLagGrace = 1;
export const knLagGuilty = 2;
export const knLagKill = 3;

// game/ht.h:5598-5618 — upgrade masks + credit consumers
export const kupgtAdvancedHRC = 0;
export const kupgtAdvancedVTS = 1;
export const kupgmAdvancedHRC = 1 << kupgtAdvancedHRC;
export const kupgmAdvancedVTS = 1 << kupgtAdvancedVTS;
export const knConsumerGeneric = 0;
export const knConsumerRepair = 1;
export const knConsumerMax = 1;

// game/ht.h:5611-5612
export const knWarehouseCapacity = 5000;
export const knProcessorCapacity = 3000;
